import { HorizontalForm } from "../../core/components/HorizontalForm";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { Form, Formik } from 'formik';
import { Box, Button, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, Text } from 'tombac';
import { CommunicationTestEmailSender } from "../CommunicationTestEmailSender";
import { useCommunicationItemQuery } from "../communicationsApiHooks";
import { useCommunicationProducts } from "../helpers/useCommunicationProducts";
import { CommunicationDateField } from "./CommunicationDateField";
import { CommunicationIsReleaseNotesField } from "./CommunicationIsReleaseNotesField";
import { CommunicationMessageField } from "./CommunicationMessageField";
import { CommunicationProductsField } from "./CommunicationProductsField";
import { CommunicationRolesField } from "./CommunicationRolesField";
import { communicationValidationSchema } from "./helpers/communicationValidationSchema";
import { useCommunicationInitialValues } from "./helpers/useCommunicationInitialValues";
import { useCommunicationSubmitHandler } from "./helpers/useCommunicationSubmitHandler";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CommunicationFormModal = _ref => {
  let {
    communicationItemId,
    initialProducts,
    initialRoles,
    onRequestClose,
    onSuccess,
    ...modalProps
  } = _ref;
  const {
    products,
    query: productsQuery
  } = useCommunicationProducts();
  const communicationItemQuery = useCommunicationItemQuery({
    communicationItemId
  }, {
    enabled: communicationItemId !== undefined
  });
  const isLoading = productsQuery.isLoading || communicationItemQuery.isLoading;
  const error = productsQuery.error || communicationItemQuery.error;
  const initialValues = useCommunicationInitialValues({
    communicationItem: communicationItemQuery.data,
    initialProducts,
    initialRoles
  });
  const {
    handleSubmit,
    isSubmitting
  } = useCommunicationSubmitHandler({
    communicationItemId,
    onSuccess
  });
  return /*#__PURE__*/_jsx(Modal, {
    ...modalProps,
    "data-sentry-element": "Modal",
    "data-sentry-component": "CommunicationFormModal",
    "data-sentry-source-file": "CommunicationFormModal.tsx",
    children: /*#__PURE__*/_jsx(Formik, {
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validateOnMount: true,
      validationSchema: communicationValidationSchema,
      "data-sentry-element": "Formik",
      "data-sentry-source-file": "CommunicationFormModal.tsx",
      "data-sentry-element": "Formik",
      children: () => /*#__PURE__*/_jsx(ModalLayout, {
        $height: "100vh",
        $width: "900u",
        as: Form,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(ModalHeader, {
            children: [communicationItemId ? 'Edit' : 'Add', " communication"]
          }), /*#__PURE__*/_jsx(ModalContent, {
            $flex: "auto",
            variant: "scrollable",
            children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : error ? /*#__PURE__*/_jsx(Box, {
              $display: "flex",
              $justifyContent: "center",
              $m: "3sp 0",
              children: /*#__PURE__*/_jsx(Text, {
                variant: "secondary",
                children: "Something went wrong"
              })
            }) : /*#__PURE__*/_jsxs(Box, {
              $display: "flex",
              $flexDirection: "column",
              $gap: "4sp",
              $minHeight: "100%",
              children: [/*#__PURE__*/_jsxs(Box, {
                $display: "flex",
                $alignItems: "end",
                children: [/*#__PURE__*/_jsx(CommunicationDateField, {
                  name: "date"
                }), /*#__PURE__*/_jsx(CommunicationIsReleaseNotesField, {
                  $mb: "1sp",
                  $ml: "4sp",
                  name: "isReleaseNotes"
                })]
              }), /*#__PURE__*/_jsxs(HorizontalForm.Root, {
                children: [/*#__PURE__*/_jsx(HorizontalForm.Group, {
                  children: /*#__PURE__*/_jsx(CommunicationProductsField, {
                    name: "products",
                    products: products
                  })
                }), /*#__PURE__*/_jsx(HorizontalForm.Group, {
                  children: /*#__PURE__*/_jsx(CommunicationRolesField, {
                    name: "roles"
                  })
                })]
              }), /*#__PURE__*/_jsx(CommunicationMessageField, {
                name: "message"
              })]
            })
          }), /*#__PURE__*/_jsxs(ModalActions, {
            secondary: /*#__PURE__*/_jsx(CommunicationTestEmailSender, {}),
            children: [/*#__PURE__*/_jsx(Button, {
              onClick: onRequestClose,
              type: "button",
              variant: "flat",
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              busy: isSubmitting,
              type: "submit",
              variant: "primary",
              children: communicationItemId ? 'Save' : 'Add notes'
            })]
          })]
        })
      })
    }, communicationItemQuery.data?.id)
  });
};